module.exports = __webpack_public_path__ + "img/image-capabilities.025ae3fd.jpg";